import { SVGProps } from "react";

export default function SlideSkipIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, fill = "#6F7782", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M21.8438 2.99609H18.679V21.003H21.8438V2.99609Z" fill={fill} />
      <path
        d="M2.15183 18.797C2.15183 20.8595 3.55593 21.611 5.27202 20.4669L14.8536 14.0792C16.5696 12.9351 16.5696 11.063 14.8536 9.91895L5.27202 3.53129C3.55593 2.38721 2.15183 3.13867 2.15183 5.20117V18.797Z"
        fill={fill}
      />
    </svg>
  );
}
